import React, { useEffect, useState, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { change } from 'redux-form';
import { GridContent } from './styled';
import {
  InputYearVehicle,
  InputModelVehicle,
  BrandVehicle,
} from '@app/src/views/StepOne/form';
import { BUILD_VEHICLE_INPUTS, getInputsForTitle } from '@app/src/config/stepOne';
import { isClientEnv } from '@app/src/utils/validations';

const isClient = isClientEnv();
const BREAKPOINT = 768;

interface Props {
  typeVehicle: number;
}

export const TitleVehicle: React.FC<Props> = ({ typeVehicle }) => {
  const dispatch = useDispatch();
  const currentYearVehicle = useSelector(state => state.form.stepOne.values.yearVehicle);
  const currentOperation = useSelector(state => state.form.stepOne.values.operation);
  const currentBrandVehicle = useSelector(state => state.form.stepOne.values.brandVehicle);
  const currentModelVehicle = useSelector(state => state.form.stepOne.values.modelVehicle);
  const [ buildInput, setBuildInput ] = useState('');
  const currentBrandVehicleName = useSelector(state => state.form.stepOne.values.brandVehicleName);
  const currentModelVehicleName = useSelector(state => state.form.stepOne.values.modelVehicleName);
  const formErrors = useSelector(state => state.form.stepOne.syncErrors);
  const [isResponsive, setIsResponsive] = useState(false);

  useEffect(() => {
    if (buildInput === BUILD_VEHICLE_INPUTS.BRAND) {
      if (currentBrandVehicle) {
        dispatch(change('stepOne', 'title', currentBrandVehicleName))
      } else {
        dispatch(change('stepOne', 'title', ''));
      }
      return;
    }
    if (buildInput === BUILD_VEHICLE_INPUTS.BRAND_ALL) {
      if (currentBrandVehicle && currentModelVehicle && currentYearVehicle) {
        if (formErrors && formErrors.yearVehicle) {
          dispatch(change('stepOne', 'title', ''))
        } else {
          dispatch(change('stepOne', 'title', `${currentBrandVehicleName} ${currentModelVehicleName} ${currentYearVehicle}`))
        }
      } else {
        dispatch(change('stepOne', 'title', ''))
      }
    }
    if (!currentYearVehicle) {
      dispatch(change('stepOne', 'title', ''));
    }
  }, [buildInput, currentBrandVehicle, currentModelVehicle, currentBrandVehicleName, currentModelVehicleName, formErrors, currentYearVehicle]);

  useEffect(() => {
    const currentInputs = getInputsForTitle(currentOperation, typeVehicle);
    setBuildInput(currentInputs);
  }, [currentOperation, typeVehicle]);

  useEffect(() => {
    if (isClient) {
      handleResizeWindow();
      window.addEventListener('resize', handleResizeWindow);
      return () => {
        dispatch(change('stepOne', 'brandVehicle', null));
        dispatch(change('stepOne', 'brandVehicleName', ''));
        dispatch(change('stepOne', 'brandAdecsys', null));
        dispatch(change('stepOne', 'modelVehicle', null));
        dispatch(change('stepOne', 'modelVehicleName', ''));
        dispatch(change('stepOne', 'modelAdecsys', null));
        dispatch(change('stepOne', 'yearVehicle', null));
        window.removeEventListener('resize', handleResizeWindow);
      }
    }
  }, []);

  const handleResizeWindow = () => {
    if (window.innerWidth >= BREAKPOINT) {
      setIsResponsive(false);
    } else {
      setIsResponsive(true);
    }
  };

  const showModelForResponsive = useCallback(() => {
    if (isResponsive) {
      return currentBrandVehicle && currentOperation && typeVehicle;
    } else {
      return currentOperation && typeVehicle;
    }
  }, [isResponsive, currentBrandVehicle, currentOperation, typeVehicle]);

  const showYearForResponsive = useCallback(() => {
    if (isResponsive) {
      return currentModelVehicle && currentBrandVehicle && currentOperation && typeVehicle;
    } else {
      return currentOperation && typeVehicle;
    }
  }, [isResponsive, currentBrandVehicle, currentOperation, typeVehicle, currentModelVehicle]);

  const getDisabledModel = useCallback(() => currentBrandVehicle ? false : true, [currentBrandVehicle]);

  const getDisabledYear = useCallback(() => currentModelVehicle ? false : true, [currentModelVehicle]);

  return(
    <GridContent buildInput={buildInput}>
      {
        (buildInput === BUILD_VEHICLE_INPUTS.BRAND || buildInput === BUILD_VEHICLE_INPUTS.BRAND_ALL) && (currentOperation && typeVehicle) &&
        <BrandVehicle typeVehicle={typeVehicle} />
      }
      {
        (buildInput === BUILD_VEHICLE_INPUTS.BRAND_ALL) && showModelForResponsive() &&
        <InputModelVehicle
          isDisabled={getDisabledModel()}
          brandVehicle={currentBrandVehicle}
          typeVehicle={typeVehicle} />
      }
      {
        (buildInput === BUILD_VEHICLE_INPUTS.BRAND_ALL) && showYearForResponsive() &&
        <InputYearVehicle modelVehicle={currentModelVehicle} isDisabled={getDisabledYear()} />
      }
    </GridContent>
  )
};
